// extracted by mini-css-extract-plugin
module.exports = {"container":"datoImage_container__2GJJF"};